import script from "./SettingsSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsSidebar.vue?vue&type=script&setup=true&lang=js"

import "./SettingsSidebar.vue?vue&type=style&index=0&id=14f5f855&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14f5f855"]])

export default __exports__